import { render, staticRenderFns } from "./pNav.vue?vue&type=template&id=7a8a1ef0&scoped=true&"
import script from "./pNav.vue?vue&type=script&lang=js&"
export * from "./pNav.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./pNav.vue?vue&type=style&index=0&id=7a8a1ef0&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7a8a1ef0",
  "651f3d1f"
  
)

export default component.exports